import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { WebcamDialogComponent } from '../webcam-dialog/webcam-dialog.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { VisualizadorImgDialogComponent } from '../visualizador-img-dialog/visualizador-img-dialog.component';

@Component({
  selector: 'app-seleccionar-servicios-dialog',
  templateUrl: './seleccionar-servicios-dialog.component.html',
  styleUrl: './seleccionar-servicios-dialog.component.scss'
})
export class SeleccionarServiciosModalComponent {

  title = ''
  llantaId = 0
  servicios = []
  servSeleccionados: any = []
  step = 1
  base64Dano
  base64Perfil
  base64Piso
  existenciaInventario = 0
  isCameraReady = false

  constructor(
    public dialogRef: MatDialogRef<SeleccionarServiciosModalComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.title = data.title
    this.servSeleccionados = data.serviciosSeleccionados
    this.existenciaInventario = data.existenciaInventario
    data.servicios.forEach(element => {
      let aux = data.serviciosSeleccionados[element.variable]

      if(aux === 1){
        aux = true
      }else if(aux === 0){
        aux = false
      }
      
      this.servicios.push({...element, checked: aux})
    });
    let serv = this.servSeleccionados.serviciosSeleccionados.find(item => item.descripcion === 'Garantía');
    if(serv){
      if(serv['img_danio'] !== undefined){
        this.base64Dano = serv['img_danio']
        this.base64Perfil = serv['img_perfil']
        this.base64Piso = serv['img_piso']
      }
    }
    this.llantaId = data.llantaId
  }

  closeDialog(){
    this.dialogRef.close({event: 2})
  }

  checkStock(){
    if(this.base64Dano !== undefined){
      return true
    }
    return this.existenciaInventario > 0 ? true : false
  }

  checkDisponibilidad(servicio){
    let serv = this.servicios.find(item => item.servicioSkuId === servicio);
    if(serv.cantidadDisponible > 0 || this.servSeleccionados[serv.variable] === 1){
      return true
    }else{
      return false
    }

  }

  guardar() {  
    if(this.servicios[5].checked){
      if(this.base64Dano !== undefined){
        let dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: '424px',
          panelClass: 'custom-dialog',
          data: {
            title: 'Tienes Imagenes Guardadas, deseas volver a capturar las imagenes para redimir la garantia?',
            description: 'Una vez aceptado, no se podrá editar la información',
            confirmText: 'Conservar Imagenes',
            cancelText: 'Volver a Capturar'
          }
        })
        dialogRef.afterClosed().subscribe(async result =>  {   
          if (result.exito) {
            this.cerrarJson()
          }else{
            this.step ++
          }
    
        });
      }else{
        this.step ++
      }
    }else{
      this.cerrarJson()
    }
  }

  cerrarJson(){
    const serviciosSeleccionados = this.servicios.filter(o => o.checked); 
    
    this.dialogRef.close({event: 1, serviciosSeleccionados, llantaId: this.llantaId})
  }

  nextStep(){
    if(this.step === 4){
      this.validarImagenes()
    }
    this.step ++
  }

  validarImagenes(){
    if(this.base64Dano !== undefined && this.base64Perfil !== undefined && this.base64Piso !== undefined){
      this.servicios[5]['img_danio'] = this.base64Dano
      this.servicios[5]['img_perfil'] = this.base64Perfil
      this.servicios[5]['img_piso'] = this.base64Perfil
      this.cerrarJson()
    }
  }
  
  tomarCaptura(opc){
    let title = ''
    if(opc === 1){
      title = 'Capturar Área dañada'
    }else if(opc === 2){
      title = 'Capturar Perfil del neumático'
    }else{
      title = 'Capturar Piso del neumático'
    }

    const dialogRef = this.dialog.open(WebcamDialogComponent, {
      panelClass: 'custom-dialog',
      disableClose: true,
      width: '100vw',
      height: 'auto',
      maxHeight: '720px',
      data: {
        title: title
      }
    });
    dialogRef.afterClosed().subscribe(async result =>  {   
      if (result.event !== 1) {
        return
      }else{
        if(opc === 1){
          this.base64Dano = result.imagen
        }else if(opc === 2){
          this.base64Perfil = result.imagen
        }else if(opc === 3){
          this.base64Piso = result.imagen
        }
      }

    });
  }

  onImage(event: { image: string; opcion: number }): void {
    console.log(event.image)
    if(event.image === 'data:,'){
      this.desactivarContinuar(event)
    }else{
      if(event.opcion === 1){
        this.base64Dano = event.image
      }else if(event.opcion === 2){
        this.base64Perfil = event.image
      }else{
        this.base64Piso = event.image
      }
    }
  }

  camaraInicializada(event){
    this.isCameraReady = event.inicializada
  }

  desactivarContinuar(event: { opcion: number }): void {
    if(event.opcion === 1){
      this.base64Dano = undefined
    }else if(event.opcion === 2){
      this.base64Perfil = undefined
    }else{
      this.base64Piso = undefined
    }
  }

  getDisabled(){
    if(this.step === 1){
      return false
    }else if(this.step === 2){
      return this.isCameraReady ? this.base64Dano !== undefined ? false : true : true
    }else if(this.step === 3){
      return this.isCameraReady ?  this.base64Perfil !== undefined ? false : true : true
    }else if(this.step === 4){
      return this.isCameraReady ? this.base64Piso !== undefined ? false : true : true
    }else{
      return false
    }
  }

  getUrlImagen(){
     if(this.step === 2){
      return ' ../../../assets/img/ejemplo-garantia/danio.jpeg'
    }else if(this.step === 3){
      return ' ../../../assets/img/ejemplo-garantia/perfil.jpeg'
    }else if(this.step === 4){
      return ' ../../../assets/img/ejemplo-garantia/piso.jpeg'
    }else{
      return false
    }
  }

  abrirImagen(img: string, i) {
    let imgS = this.getUrlImagen()
    let array = [
      imgS
    ]
      this.dialog.open(VisualizadorImgDialogComponent, {
        // width: '100vw',
        // height: '100vh',z
        data: { imgs: array, indexSelected: 0 },
        panelClass: 'custom-dialog',
      });
    }

  getLabelStep(){
    if(this.step === 2){
      return 'Área dañada'
    }else if(this.step === 3){
      return 'Perfil del neumático'
    }else if(this.step === 4){
      return 'Piso del neumático'
    }else{
      return false
    }
  }
}